import { TypeSacCremation } from "../TypeSacCremation"

export class DataModelUpdateStatutCommande {
    etiquette: number = 0
    typeSac: TypeSacCremation = new TypeSacCremation()
    statuCommandeId: number = 0
}